import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../shared/shared.service';

@Component({
  selector: 'app-create-agency',
  templateUrl: './create-agency.component.html',
  styleUrls: ['./create-agency.component.css']
})
export class CreateAgencyComponent implements OnInit {

  public formType: String;
  private sub: any;

  constructor(private route: ActivatedRoute, private sharedService : SharedService) { 
  }

  ngOnInit() {      	
    this.sharedService.showAgencyInformation = true;
    this.sub = this.route.params.subscribe(params => {
      this.formType = params['formType'];
      if(this.formType == 'createAgency' || this.formType == 'modifyAgency') {
        this.sharedService.publishCurrentPage('Agency');
        //this.sharedService.currentPageName = "Agency";
      } else if(this.formType == 'createAgent' || this.formType == 'modifyAgent') {
        this.sharedService.publishCurrentPage('Agent');
        //this.sharedService.currentPageName = "Agent";
       } //else if(this.formType == 'doTopUp') {
      //   this.sharedService.publishCurrentPage('TopUp');
      //   //this.sharedService.currentPageName = "Agent";
      // }
    });
  }

  ngOnDestroy(){
  	//this.sharedService.currentPageName = "";
  	this.sharedService.showAgencyInformation = false;
  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/create-agency/create-agency.component.ts